import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { ArrowUpCircleFill } from 'react-bootstrap-icons'
import { SCROLL_TO_TOP_TEXT } from 'assets/constants'

const ScrollToTopButton = () => {
  const [isHidden, setIsHidden] = useState(true)
  const showElementAfter = 200

  useEffect(() => {
    window.addEventListener('scroll', hideElement)
    return () => {
      window.removeEventListener('scroll', hideElement)
    }
  }, [])

  const hideElement = () => {
    window.scrollY > showElementAfter ? setIsHidden(false) : setIsHidden(true)
  }

  return (
    <Button
      className={`scroll-to-top ${isHidden ? 'd-none' : ''}`}
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }}
      variant="light"
    >
      <span className="visually-hidden">{SCROLL_TO_TOP_TEXT}</span>
      <ArrowUpCircleFill className="scroll-to-top__icon" size={60}></ArrowUpCircleFill>
    </Button>
  )
}

export default ScrollToTopButton
